import { client } from '../client';
import { IOneReport } from './types/IOneReport';
import { ObjectType } from './updateOneReportObject';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const deleteOneReportObject = async (
  one_report_id: string,
  object_id: string,
  object_type: ObjectType,
  userRole?: string,
): Promise<IOneReport> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.delete<IOneReport>(
    `${prefix}/one_reports/${one_report_id}/${object_type}/${object_id}`,
  );

  return data;
};
